<div *ngIf="loading; else loaded">Loading...</div>

<ng-template #loaded>
  <div *ngIf="aircraftBillingRateAudits && aircraftBillingRateAudits.length > 0; else noAudits">
    <sd-portal-audit-detail-list
      (nextPage)="onNextPage()"
      [audits]="aircraftBillingRateAudits"
    ></sd-portal-audit-detail-list>
  </div>
  <ng-template #noAudits> No Aircraft Billing Rate audits </ng-template>
</ng-template>
